import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[date]'
})
export class DateInputDirective {
  @Input() timeless: string | boolean;
}
